<template>
  <div v-if="OrderInfo" class="confirm-order">
    <iHeader />
    <iNav :search="false" :car-btn="false" :phone="false" :title="false" content>
      <div slot="content" class="carName">
        <div class="cn">核对订单</div>
        <img style="width: 396px;" src="../../assets/buycar/step1.png">
      </div>
    </iNav>
    <div v-if="OrderInfo.DiscountAmount>0 && OrderInfo.DiscountDescription" class="card">
      <div class="customer-title">
        <!--                <span>您在2021年1月23日-2021年3月21日期间下单(不限订单金额)可享受9.5折优惠</span>-->
        <span>{{ OrderInfo.DiscountDescription }}</span>
        <!-- <span
          style="color: red;"
        >订单已优惠金额：{{ _moneyFormat(OrderInfo.TotalDiscount) }}元</span> -->
      </div>
    </div>
    <!-- 活动信息 -->
    <!-- 		<div class="active-panel">
			<div class="active-list" v-for="(item,index) in activityList" :key="index">
				<div class="ac-tag">{{item.name}}</div>
				<div class="ac-gifts">
					<div class="ac-content" v-for="(c,i) in item.gifts" :key="i" v-if=" item.show ? true : i <3 ">
						<div>指定商品金额满1000，赠送10盒阿莫西林胶囊</div>
						<div class="ac-is-gift">已赠送</div>
					</div>
					<div class="more-three" v-if="item.gifts.length > 3" @click="changeShow(item)">
						<div v-if="!item.show">展开全部 <i class="el-icon-arrow-down"></i></div>
						<div v-else>收起全部 <i class="el-icon-arrow-up"></i></div>
					</div>
				</div>

			</div>
		</div> -->
    <!-- 收货信息 -->
    <div class="card">
      <div class="card-t">收货信息</div>
      <div class="card-i">
        <div class="revc-info-itm">
          <div class="left">客户名称：</div>
          <div class="right">
            {{ OrderInfo.CustomerReceivingAddress.CustomerName }}
          </div>
          <div class="tips">
            <router-link
              target="_blank"
              :to="LinkTypeCode.AddressShow"
            >收货信息错误？</router-link>
          </div>
        </div>
        <div class="revc-info-itm">
          <div class="left">收货人：</div>
          <div class="right">
            {{ OrderInfo.CustomerReceivingAddress.ReceivingMan || '' }}
          </div>
        </div>
        <div class="revc-info-itm">
          <div class="left">联系电话：</div>
          <div class="right">
            {{ OrderInfo.CustomerReceivingAddress.Phone || '' }}
          </div>
        </div>
        <div class="revc-info-itm">
          <div class="left">收货地址：</div>
          <div class="right">
            <span>{{
              OrderInfo.CustomerReceivingAddress.Area
                ? OrderInfo.CustomerReceivingAddress.Area.Province
                : ''
            }}</span>
            <span>{{
              OrderInfo.CustomerReceivingAddress.Area
                ? OrderInfo.CustomerReceivingAddress.Area.City
                : ''
            }}</span>
            <span>{{
              OrderInfo.CustomerReceivingAddress.Area
                ? OrderInfo.CustomerReceivingAddress.Area.County
                : ''
            }}</span>
            <span>{{
              setStreet(
                OrderInfo.CustomerReceivingAddress.Address,
                OrderInfo.CustomerReceivingAddress.AddressName
              ) || ''
            }}</span>
          </div>
          <div
            v-if="OrderInfo.CustomerReceivingAddressList.length == 2"
            class="tips flex align-items-center"
            style=" font-size: 14px; color: #666F83; cursor: pointer;"
            @click.stop="
              () => {
                show_address = true
              }
            "
          >
            更换收货地址
            <i class="el-icon-arrow-right" />
          </div>
        </div>
      </div>
      <div class="card-f" />
    </div>
    <!--
      * 新需求开发
      * 选择收货地址方式
      * liutao
      * 2021.08.18
    -->
    <a-modal
      v-model="show_address"
      centered
      :footer="null"
      :closable="false"
      :mask-closable="false"
      width="494px"
      :body-style="{ padding: 0 }"
    >
      <div class="flex-invoice-box address-box">
        <div class="flex-invoice-header address-header">
          选择收货地址
          <img
            class="image-close"
            src="../../assets/buycar/model-close.png"
            @click="
              () => {
                show_address = false
                getCreateOrderInfoParams.OrderReceivedCustomerId =
                  OrderInfo.CustomerReceivingAddress.CustomerId
              }
            "
          >
        </div>
        <div class="text-center" style="margin-bottom: 32px;">
          <el-radio-group
            v-model="getCreateOrderInfoParams.OrderReceivedCustomerId"
            class="text-left"
          >
            <el-card
              v-for="item in OrderInfo.CustomerReceivingAddressList"
              :key="item.Id"
              style="margin-top: 20px;"
              shadow="hover"
              :body-style="{ padding: '0px' }"
            >
              <el-radio :label="item.CustomerId" border>
                <el-tag v-if="item.storeType == 1" size="small">总店</el-tag>
                <el-tag v-else size="small">当前门店</el-tag>
                <span class="outbound-name">{{ item.CustomerName }}</span>
                <div class="outbound-tax">
                  {{ item.ReceivingMan }} {{ item.Phone }}
                </div>
                <div class="outbound-address">
                  <i class="el-icon-location-outline">{{ item.AddressName }}</i>
                </div>
                <img
                  src="../../assets/buycar/choose.png"
                  class="choose-adress"
                >
              </el-radio>
            </el-card>
          </el-radio-group>
          <div id="" class="" style="margin-top: 48px;">
            <el-button
              type="primary"
              style="width: 160px;"
              @click="comfirmChooseAddress()"
            >确定</el-button>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- 选择收货 end -->
    <!--
      * 新需求开发
      * 配送方式
      * xuzhongqi
      * 2020.12.04
      -->
    <div class="card">
      <div class="card-t">配送方式</div>
      <div class="flex-box">
        <div class="flex-row-l">
          <div class="flex-row-l-list">
            <div v-if="ExressName === '顺丰物流'">
              <img class="img" src="../../assets/buycar/express-sf.png">
            </div>
            <div v-else-if="ExressName === '京东快递'">
              <img class="img" src="../../assets/buycar/express-jd.png">
            </div>
            <div v-else class="txt">{{ ExressName }}</div>
          </div>
        </div>
        <div class="flex-row-r">
          <span @click="tipsModel = true">
            <a-icon type="question-circle" />
            物流说明
          </span>
        </div>
      </div>
    </div>
    <!-- 配送方式 end -->

    <!--
      * 物流说明 model
      * xuzhongqi
      * 2020.12.04
      -->
    <a-modal
      v-model="tipsModel"
      centered
      :footer="null"
      :closable="false"
      width="610px"
    >
      <div class="tips-cont">
        <div class="tips-row">
          <h4>物流说明</h4>
          <img
            class="image-close"
            src="../../assets/buycar/model-close.png"
            @click="() => (tipsModel = false)"
          >
        </div>
        <div class="tips-row"><label>配送时间说明</label></div>
        <div class="tips-row tips-flex-box">
          <div class="tips-flex-row rendering">
            <div>下单时间</div>
            <div>发货时间</div>
          </div>
          <div class="tips-flex-row">
            <div>周一到周五17点前</div>
            <div>当天发货</div>
          </div>
          <div class="tips-flex-row rendering">
            <div>周五17点后到周六17点</div>
            <div>周六或周日发货</div>
          </div>
          <div class="tips-flex-row">
            <div>周六17点之后及周日全天</div>
            <div>周一发货</div>
          </div>
          <div class="tips-flex-row rendering">
            <div>节假日</div>
            <div>另行通知</div>
          </div>
        </div>
        <div class="tips-row">
          <p class="tips-footer-label">备注:</p>
          <p>1、春节假日发货时间可能有变动，具体可咨询客服。</p>
          <p>2、配送时间一般不超过3-6天，自然灾害等不可抗拒因素除外。</p>
        </div>
      </div>
    </a-modal>
    <!-- 物流说明 model end -->

    <!-- 商品信息 -->
    <div class="card">
      <div class="card-t">
        商品信息
        <span style="margin-left: 504px;">单价</span>
        <span style="margin-left: 135px;">数量</span>
        <span style="margin-left: 136px;">小计</span>
        <span style="margin-left: 140px;">实付</span>
      </div>
      <div class="card-i" style="padding: 0;">
        <div
          v-for="(goods, key) in OrderInfo.Commoditys"
          :key="key+'a'"
        >
          <ProductDetails :goods="goods" :type="goods.ActivityCode" :gift-type="0" />
        </div>
        <!-- 换购 -->
        <div
          v-for="(goods, key) in OrderInfo.CommodityExchanges"
          :key="key+'b'"
        >
          <ProductDetails v-if="goods.Count" :goods="goods" :gift-type="2" />
        </div>
        <!-- 赠品 -->
        <div
          v-for="(goods, key) in OrderInfo.CommodityFreebies"
          :key="key+'c'"
        >
          <ProductDetails v-if="goods.Count" :goods="goods" :gift-type="1" />
        </div>
      </div>
    </div>

    <!--
      * 新需求开发
      * 优惠券 入口按钮重设计
      * xuzhongqi
      * 2020.12.04
      -->
    <div class="card">
      <div class="card-t">使用优惠券</div>
      <div class="coupon-box">
        <div class="msg-coupon">
          <span v-if="!OrderInfo.CouponsCanUse.length">无可用优惠券</span>
          <span v-else>
            <span
              v-if="OrderInfo.Coupons"
              class="up-down"
              @click.stop="isShowCoupon = !isShowCoupon"
            >
              选择优惠券
              <a-icon v-if="isShowCoupon" type="up" />
              <a-icon v-if="!isShowCoupon" type="down" />
            </span>
            <span v-if="!OrderInfo.Coupon" class="c-num">
              共
              {{
                OrderInfo.CouponsCanNotUse.length +
                  OrderInfo.CouponsCanUse.length
              }}
              张优惠券，其中 {{ OrderInfo.CouponsCanUse.length }} 张可用
            </span>
            <span v-if="chooseCouponInfo.Id" class="s-text">已选择优惠券</span>
            <span v-if="chooseCouponInfo.Id" class="coupon-s">{{
              chooseCouponInfo.SimpleName
            }}</span>
          </span>
        </div>
        <div v-if="isShowCoupon" class="coupon-content">
          <div class="head">
            <div
              class="item"
              :class="{ active: tabIndex == 0 }"
              @click="handleTabsChange(0)"
            >
              可用优惠券({{ OrderInfo.CouponsCanUse.length }})
            </div>
            <div
              class="item"
              :class="{ active: tabIndex == 1 }"
              @click="handleTabsChange(1)"
            >
              不可用优惠券({{ OrderInfo.CouponsCanNotUse.length }})
            </div>
          </div>
          <div class="cs-box">
            <div v-if="tabIndex == 0" class="c-p">
              <EmptyControl
                v-if="
                  !OrderInfo.CouponsCanUse ||
                    OrderInfo.CouponsCanUse.length == 0
                "
                type="coupon"
                text="暂无可用优惠券哦～"
              />
              <!-- 可用优惠券列表 -->
              <div
                v-for="(itm, index) in OrderInfo.CouponsCanUse"
                :key="itm.Id + index"
                class="coupon-item"
                :class="{ 'is-select': itm.IsSelected }"
                @click.stop="onCouponChanged(1, itm)"
              >
                <div class="left" :class="{ 'disabled-left': !itm.IsCanUse }">
                  <span v-if="itm.DeductionMode == 1">
                    {{ itm.DeductionLimit }}
                    <img
                      v-if="itm.IsCanUse"
                      src="../../assets/coupon-money.png"
                    >
                    <img v-else src="../../assets/coupon-money-disable.png">
                  </span>
                  <span v-if="itm.DeductionMode == 2">
                    {{ (itm.DeductionLimit * 10).toFixed(1) }}
                    <img
                      v-if="itm.IsCanUse"
                      src="../../assets/coupon-discount.png"
                    >
                    <img
                      v-else
                      src="../../assets/coupon-discount-disabled.png"
                    >
                  </span>
                  <span v-if="itm.DeductionMode == 3">
                    全
                    <img
                      v-if="itm.IsCanUse"
                      src="../../assets/coupon-money.png"
                    >
                    <img v-else src="../../assets/coupon-money-disable.png">
                  </span>
                  <span
                    v-if="itm.GoodsLimitPrice > 0"
                  >满{{ itm.GoodsLimitPrice }}元立减</span>
                  <span
                    v-if="itm.GoodsLimitNumber > 0"
                  >满{{ itm.GoodsLimitNumber }}盒立减</span>
                </div>
                <div class="right" :class="{ 'disabled-box': !itm.IsCanUse }">
                  <div style="font-size: 0;">
                    <div class="q-tag">
                      {{
                        itm.OutCouponLimitGoodsDtos &&
                          itm.OutCouponLimitGoodsDtos.length > 0
                          ? '商品券'
                          : '现金券'
                      }}
                    </div>
                    <span class="name">
                      <span v-if="itm.type == 1">全场通用</span>
                      <span v-if="itm.type == 2">原价商品可用</span>
                      <span v-if="itm.type == 3">指定活动可用</span>
                      <span v-if="itm.type == 4">指定商品可用</span>
                      <span v-if="itm.type == 5">
                        仅购买【{{
                          itm.OutCouponLimitGoodsDtos[0].GoodsName
                        }}】可用
                      </span>
                    </span>
                  </div>
                  <div v-if="itm.ValidityEndTime" class="date">
                    有效期至：{{ itm.ValidityEndTime }}
                  </div>
                  <div v-if="itm.FailureDays" class="date">
                    领取后{{ itm.FailureDays }}天有效
                  </div>

                  <div class="gz">
                    <span class="gz-btn">
                      使用规则
                      <a-icon type="up" class="up" />
                      <a-icon type="down" class="down" />
                    </span>
                    <span v-if="itm.type == 4 || itm.type == 5">
                      <template>
                        <van-button
                          class="infoBtn_class"
                          loading-text="加载中..."
                          @click.stop="moreInfoBtn(itm)"
                        >查看详情</van-button>
                      </template>
                    </span>
                    <div class="coupon-dis">
                      <div class="dis-item">
                        <div class="lable">使用说明：</div>
                        <div class="dis-text">
                          <span
                            v-if="itm.GoodsLimitPrice"
                          >满{{ itm.GoodsLimitPrice }}元可用</span>
                          <span
                            v-if="itm.GoodsLimitNumber"
                          >满{{ itm.GoodsLimitNumber }}盒可用</span>
                        </div>
                      </div>
                      <div class="dis-item">
                        <div class="dis-text">
                          <!-- <template v-if="!itm.OutCouponLimitGoodsDtos || !itm.OutCouponLimitGoodsDtos.length">
                                                        全场通用
                                                    </template>
                                                    <template v-else>
                                                        仅限购买{{
															itm.OutCouponLimitGoodsDtos.map(i => {
																return i.GoodsName;
															}).join('、')
														}}
                                                    </template> -->
                          <p>
                            使用权限：
                            <template v-if="itm.type == 1">全场通用</template>
                            <template
                              v-if="itm.type == 2"
                            >原价商品可用</template>
                            <template
                              v-if="itm.type == 3"
                            >仅限购买指定活动中的商品</template>
                            <template
                              v-if="itm.type == 4 || itm.type == 5"
                            >仅限购买:</template>
                          </p>
                          <p v-if="itm.type == 4 || itm.type == 5">
                            <template>{{
                              itm.OutCouponLimitGoodsDtos.map((i) => {
                                return i.GoodsName
                              }).join('、')
                            }}</template>
                          </p>

                          <p v-if="itm.type == 3">
                            <template
                              style="padding-left: 2px;"
                            ><span
                              v-for="(t, index) in itm.SpecialActivityList"
                              :key="index"
                            >{{
                              t +
                                (index != itm.SpecialActivityList.length - 1
                                  ? '、'
                                  : '')
                            }}</span></template>
                          </p>
                          <p v-if="itm.type == 3">
                            <template
                              style="padding-left: 2px;"
                            ><span
                              v-for="(t, index) in itm.ActivityList"
                              :key="index"
                            >{{
                              t +
                                (index != itm.ActivityList.length - 1
                                  ? '、'
                                  : '')
                            }}</span></template>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="itm.IsSelected" class="s-icon" />
              </div>
            </div>
            <div v-if="tabIndex == 1" class="c-p">
              <EmptyControl
                v-if="
                  !OrderInfo.CouponsCanNotUse ||
                    OrderInfo.CouponsCanNotUse.length == 0
                "
                type="coupon"
                text="暂无不可用优惠券哦～"
              />
              <!-- 不可用优惠券列表 -->
              <div
                v-for="(itm, index) in OrderInfo.CouponsCanNotUse"
                :key="itm.Id + index"
                class="coupon-item"
                :class="{ 'is-select': itm.IsSelected }"
              >
                <div class="left" :class="{ 'disabled-left': !itm.IsCanUse }">
                  <span v-if="itm.DeductionMode == 1">
                    {{ itm.DeductionLimit }}
                    <img
                      v-if="itm.IsCanUse"
                      src="../../assets/coupon-money.png"
                    >
                    <img v-else src="../../assets/coupon-money-disable.png">
                  </span>
                  <span v-if="itm.DeductionMode == 2">
                    {{ (itm.DeductionLimit * 10).toFixed(1) }}
                    <img
                      v-if="itm.IsCanUse"
                      src="../../assets/coupon-discount.png"
                    >
                    <img
                      v-else
                      src="../../assets/coupon-discount-disabled.png"
                    >
                  </span>
                  <span v-if="itm.DeductionMode == 3">
                    全
                    <img
                      v-if="itm.IsCanUse"
                      src="../../assets/coupon-money.png"
                    >
                    <img v-else src="../../assets/coupon-money-disable.png">
                  </span>
                  <span
                    v-if="itm.GoodsLimitPrice > 0"
                  >满{{ itm.GoodsLimitPrice }}元可用</span>
                  <span
                    v-if="itm.GoodsLimitNumber > 0"
                  >满{{ itm.GoodsLimitNumber }}盒可用</span>
                </div>
                <div class="right" :class="{ 'disabled-box': !itm.IsCanUse }">
                  <div style="font-size: 0;" class="ellips-text">
                    <div class="q-tag">
                      {{
                        itm.OutCouponLimitGoodsDtos &&
                          itm.OutCouponLimitGoodsDtos.length > 0
                          ? '商品券'
                          : '现金券'
                      }}
                    </div>
                    <span class="name">
                      <span v-if="itm.type == 1">全场通用</span>
                      <span v-if="itm.type == 2">原价商品可用</span>
                      <span v-if="itm.type == 3">指定活动可用</span>
                      <span v-if="itm.type == 4">指定商品可用</span>
                      <span v-if="itm.type == 5">
                        仅购买【{{
                          itm.OutCouponLimitGoodsDtos[0].GoodsName
                        }}】可用
                      </span>
                    </span>
                  </div>
                  <div v-if="itm.ValidityEndTime" class="date">
                    有效期至：{{ itm.ValidityEndTime }}
                  </div>
                  <div v-if="itm.FailureDays" class="date">
                    领取后{{ itm.FailureDays }}天有效
                  </div>

                  <div class="gz">
                    <span class="gz-btn">
                      使用规则
                      <a-icon type="up" class="up" />
                      <a-icon type="down" class="down" />
                    </span>
                    <span v-if="itm.type == 4 || itm.type == 5">
                      <template>
                        <van-button
                          class="infoBtn_class"
                          loading-text="加载中..."
                          @click.stop="moreInfoBtn(itm)"
                        >查看详情</van-button>
                      </template>
                    </span>
                    <div class="coupon-dis">
                      <div class="dis-item">
                        <div class="lable">使用说明：</div>
                        <div class="dis-text">
                          <span
                            v-if="itm.GoodsLimitPrice > 0"
                          >满{{ itm.GoodsLimitPrice }}元可用</span>
                          <span
                            v-if="itm.GoodsLimitNumber > 0"
                          >满{{ itm.GoodsLimitNumber }}盒可用</span>
                        </div>
                      </div>
                      <div class="dis-item">
                        <div class="dis-text">
                          <!-- <template v-if="!itm.OutCouponLimitGoodsDtos || !itm.OutCouponLimitGoodsDtos.length">
                                                        全场通用
                                                    </template>
                                                    <template v-else>
                                                        仅限购买{{
															itm.OutCouponLimitGoodsDtos.map(i => {
																return i.GoodsName;
															}).join('、')
														}}
                                                    </template> -->
                          <p>
                            使用权限：
                            <template v-if="itm.type == 1">全场通用</template>
                            <template
                              v-if="itm.type == 2"
                            >原价商品可用</template>
                            <template
                              v-if="itm.type == 3"
                            >仅限购买指定活动中的商品</template>
                            <template
                              v-if="itm.type == 4 || itm.type == 5"
                            >仅限购买:</template>
                          </p>
                          <p v-if="itm.type == 4 || itm.type == 5">
                            <template>{{
                              itm.OutCouponLimitGoodsDtos.map((i) => {
                                return i.GoodsName
                              }).join('、')
                            }}</template>
                          </p>
                          <p v-if="itm.type == 3">
                            <template
                              style="padding-left: 2px;"
                            ><span
                              v-for="(t, index) in itm.SpecialActivityList"
                              :key="index"
                            >{{
                              t +
                                (index != itm.SpecialActivityList.length - 1
                                  ? '、'
                                  : '')
                            }}</span></template>
                          </p>
                          <p v-if="itm.type == 3">
                            <template
                              style="padding-left: 2px;"
                            ><span
                              v-for="(t, index) in itm.ActivityList"
                              :key="index"
                            >{{
                              t +
                                (index != itm.ActivityList.length - 1
                                  ? '、'
                                  : '')
                            }}</span></template>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="itm.IsSelected" class="s-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="flex-box">
                <div class="flex-classification">
                    <div class="flex">
                        <span class="fill-l">{{ !OrderInfo.Coupon ? '选择优惠券' : OrderInfo.Coupon.SimpleName }}</span>
                        <span class="fill-c"></span>
                        <span class="fill-r"
                              @click="show_coupon = true">{{ !OrderInfo.Coupon ? '选择' : '更换' }}</span>
                    </div>
                </div>
            </div>
            <div class="flex-tips">
                共 {{ OrderInfo.CouponsCanNotUse.length + OrderInfo.CouponsCanUse.length }} 张优惠券，其中
                <span style="color:#0F6EEA">{{ OrderInfo.CouponsCanUse.length }}</span>
                张可用
            </div> -->
    </div>
    <!-- 优惠券 end -->

    <!--
      * 新需求开发-需求更改添加出库单/开票单位
      * 发票信息 入口按钮重设计
      * xuzhongqi,liutao
      * 2020.12.04  2021.08.19
      -->
    <div class="card outbound-unit">
      <div class="card-t">出库单/开票单位</div>
      <div class="text-left" style="padding: 20px;">
        <div class="outbound-tips">选择主体单位后、申请发票时不允许修改</div>
        <div>
          <el-radio-group
            v-model="getCreateOrderInfoParams.OrderInvoiceCustomerId"
            class="text-left"
            @change="chooseInvose()"
          >
            <el-card
              v-for="item in CustomerList"
              :key="item.Id"
              shadow="hover"
              :body-style="{ padding: '0px' }"
            >
              <el-radio :label="item.Id" border>
                <el-tag v-if="!item.IsMain" size="small">当前门店</el-tag>
                <el-tag v-else size="small">总店</el-tag>
                <span class="outbound-name">{{ item.StoreName }}</span>

                <div class="outbound-tax">
                  纳税人识别号:{{ item.TaxNumber }}
                </div>
                <img
                  src="../../assets/buycar/choose.png"
                  class="choose-adress"
                >
              </el-radio>
            </el-card>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div v-if="isBoolean" class="card">
      <div class="card-t">开票信息</div>
      <div class="flex-box">
        <div class="flex-classification">
          <div class="flex" @click="show_price = true">
            <span class="fill-l">{{ priceType }}</span>
            <span class="fill-c" />
            <span class="fill-r">更换</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 发票信息 end -->
    <!--
      * 发票信息 model
      * xuzhongqi
      * 2020.12.04
      -->
    <a-modal
      v-model="show_price"
      centered
      :footer="null"
      :closable="false"
      :mask-closable="false"
      width="900px"
      :body-style="{ padding: 0 }"
    >
      <div class="flex-invoice-box">
        <div class="flex-invoice-header">
          申请开票
          <img
            class="image-close"
            src="../../assets/buycar/model-close.png"
            @click="() => (show_price = false)"
          >
        </div>
        <div class="flex-invoice-body">
          <div class="flex-invoice-switch">
            <div class="flex-invoice-label">发票类型</div>
            <div class="flex-invoice-radio">
              <a-radio-group
                v-model="selected_canuse_receipt"
                :options="hasSwitchOptions"
                @change="onChangeSwitch"
              />
            </div>
            <div
              v-show="selected_canuse_receipt === 2"
              class="flex-invoice-msg"
            >
              <label>提醒：</label>
              增值税专用发票开具需2-3个工作日，为避免您的等待，推荐您开具电子普通发票！
            </div>
          </div>
          <div class="flex-invoice-form">
            <div class="flex-invoice-label">发票信息</div>
            <!-- 电子普通发票 -->
            <div v-if="selected_canuse_receipt != 2" class="table">
              <div class="row">
                <em />
                <a-input
                  v-model="form2.CorporateName"
                  class="icon"
                  :disabled="chooseInvoice.IsMain"
                  placeholder="请填写发票抬头"
                  @blur="checkName(form2.CorporateName)"
                />
              </div>
              <!-- 非营利性诊所电子普通发票隐藏税号信息 && -->
              <div
                v-if="
                  detailInfo.CustomerType === 1 ||
                    (detailInfo.CustomerType === 2 &&
                      detailInfo.BusinessNature === 1)
                "
                class="row"
              >
                <a-input
                  v-model="form2.IdentificationNumber"
                  :disabled="chooseInvoice.IsMain"
                  placeholder="请填写纳税人识别号"
                />
              </div>
              <div class="row">
                <p>提醒:</p>
                <p>
                  平台默认开具电子普通发票，电子普通发票是税局认可的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质普通发票可自行下载打印。
                </p>
              </div>
            </div>
            <!-- 增值税专用发票 -->
            <div v-if="selected_canuse_receipt === 2" class="table">
              <div class="row flex">
                <div class="row-l">
                  <div class="row">
                    <em />
                    <a-input
                      v-model="form.CorporateName"
                      :disabled="chooseInvoice.IsMain"
                      class="icon"
                      placeholder="请填写发票抬头"
                      @blur="checkName(form.CorporateName)"
                    />
                  </div>
                  <div class="row">
                    <em />
                    <a-input
                      v-model="form.IdentificationNumber"
                      :disabled="chooseInvoice.IsMain"
                      class="icon"
                      placeholder="请填写纳税人识别号"
                    />
                  </div>
                  <div class="row">
                    <em />
                    <a-input
                      v-model="form.Address"
                      :disabled="chooseInvoice.IsMain"
                      class="icon"
                      placeholder="请填写门店地址"
                    />
                  </div>
                  <div class="row">
                    <em />
                    <a-input
                      v-model="form.Phone"
                      :disabled="chooseInvoice.IsMain"
                      class="icon"
                      placeholder="请填写联系人电话"
                    />
                  </div>
                  <div class="row">
                    <em />
                    <a-input
                      v-model="form.BankDeposit"
                      :disabled="chooseInvoice.IsMain"
                      class="icon"
                      placeholder="请填写开户银行"
                    />
                  </div>
                  <div class="row">
                    <em />
                    <a-input
                      v-model="form.BankAccount"
                      :disabled="chooseInvoice.IsMain"
                      class="icon"
                      placeholder="请填写银行账号"
                    />
                  </div>
                </div>
                <div class="row-r" style="flex: 0 0 45%;">
                  <!-- 图片上传 -->
                  <!-- <div>
                    <img
                      width="10px"
                      height="10px"
                      style="margin: -2px 5px 0 0;"
                      src="../../assets/buycar/swtch-icon.png"
                    >
                    上传开票资料
                  </div> -->
                  <van-grid>
                    <div class="iFile-tips" style="width: 100%;">
                      <img
                        width="10px"
                        height="10px"
                        style="margin: -2px 5px 0 0;"
                        src="../../assets/buycar/swtch-icon.png"
                      >上传一般人纳税人申请表</div>
                    <van-grid-item
                      v-for="(item, index) in conUploader"
                      :key="index"
                      class="grid-item"
                    >
                      <iFile
                        style="width: 100px; height: 100px;"
                        :bg="_getPic(item.ImageUrl, true)"
                        :readonly="chooseInvoice.IsMain"
                      >
                        <van-icon
                          name="clear"
                          size="20px"
                          style="position: absolute; top: -18px; left: 0;"
                          @click.stop="delImage(index)"
                        />
                      </iFile>
                    </van-grid-item>
                    <iFile
                      v-if="conUploader.length == 0"
                      class="grid-item"
                      :readonly="chooseInvoice.IsMain"
                      @change="onFile"
                    >
                      <img
                        width="36px"
                        height="36px"
                        style="margin-top: 30px;"
                        src="../../assets/mine/xiangji.png"
                      >
                    </iFile>
                  </van-grid>
                  <van-grid>
                    <span class="iFile-tips">
                      <!-- <img
                        width="10px"
                        height="10px"
                        style="margin: -2px 5px 0 0;"
                        src="../../assets/buycar/swtch-icon.png"
                      > -->
                      上传汇总纳税申请表（分店开连锁总部需上传）</span>
                    <van-grid-item
                      v-for="(item, index) in conUploader2"
                      :key="index"
                      class="grid-item"
                    >
                      <iFile
                        style="width: 100px; height: 100px;"
                        :bg="_getPic(item.ImageUrl, true)"
                        :readonly="chooseInvoice.IsMain"
                      >
                        <van-icon
                          name="clear"
                          size="20px"
                          style="position: absolute; top: -18px; left: 0;"
                          @click.stop="delImage2(index)"
                        />
                      </iFile>
                    </van-grid-item>
                    <iFile
                      v-if="conUploader2.length == 0"
                      class="grid-item"
                      :readonly="chooseInvoice.IsMain"
                      @change="onFile2"
                    >
                      <img
                        width="36px"
                        height="36px"
                        style="margin-top: 30px;"
                        src="../../assets/mine/xiangji.png"
                      >
                    </iFile>
                  </van-grid>
                </div>
              </div>
              <div class="row">
                <p>提醒:</p>
                <p>
                  平台默认开具电子普通发票，电子普通发票是税局认可的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质普通发票可自行下载打印。
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selected_canuse_receipt != 2" class="flex-invoice-footer">
          <van-button
            @click="
              () => {
                show_price = false
                selected_canuse_receipt = 0
                priceType = '暂不开票'
              }
            "
          >
            暂不开票
          </van-button>
          <van-button
            color="#0F6EEA"
            :disabled="!form2.CorporateName"
            @click.stop="
              () => {
                toPrice()
              }
            "
          >
            确定
          </van-button>
        </div>
        <div v-if="selected_canuse_receipt === 2" class="flex-invoice-footer">
          <van-button
            @click="
              () => {
                show_price = false
                selected_canuse_receipt = 0
                priceType = '暂不开票'
              }
            "
          >
            暂不开票
          </van-button>
          <van-button
            color="#0F6EEA"
            :disabled="
              !(
                OrderInfo.ActualAmount >= 500 &&
                form.CorporateName &&
                form.IdentificationNumber &&
                form.Address &&
                form.Phone &&
                form.BankDeposit &&
                form.BankAccount &&
                conUploader.length > 0
              )
            "
            @click.stop="
              () => {
                toPrice()
                selected_canuse_receipt = 2
              }
            "
          >
            确定
          </van-button>
        </div>
      </div>
    </a-modal>
    <!-- 发票信息 model end -->
    <!--
      * 温馨提示 model
      * haolin.hu
      * 2022.2.15
      -->
    <a-modal
      v-model="show_remind"
      centered
      :footer="null"
      :closable="false"
      :mask-closable="false"
      width="573px"
      :body-style="{ padding: 0 }"
    >
      <div class="flex-remind-box">
        <div class="flex-remind-header">
          温馨提示
          <img
            class="image-close"
            src="../../assets/buycar/model-close.png"
            @click="() => {
              show_remind = false
              selected_canuse_receipt!=2 ? form2.CorporateName = chooseInvoice.Name || auth.getCustomerName() : form.CorporateName = chooseInvoice.Name || auth.getCustomerName()
            }"
          >
        </div>
        <div v-if="difference===1 || !!IsHead" class="flex-remind-body">
          <div class="subtitle">检测到您发票抬头与门店名称不一致，您是否需要修改门店名称？</div>
          <div class="block">
            <div>1. 门店名称修改后，后续所有发票和出库单都以新抬头开具。</div>
            <div>2. 门店名称修改之前的订单【出库单】和【发票】修改请联系客服。【联系客服：4001818000】</div>
          </div>
        </div>
        <div v-else>
          <div v-if="difference===2 && CustomerList.length>1" class="flex-remind-body">
            <div class="subtitle">检测到您发票抬头与门店名称差异较大：</div>
            <div class="block">
              <div>1. 您是否需要切换开票单位？<span class="link" @click="changeCompany">切换开票单位</span></div>
              <div>2. 门店名称修改之前的订单【出库单】和【发票】修改请联系客服。【联系客服：4001818000】</div>
            </div>
          </div>
          <div v-if="difference===2 && CustomerList.length===1" class="flex-remind-body">
            <div class="subtitle">检测到您发票抬头与门店名称差异较大：</div>
            <div class="block">
              <div>1. 您是否需要绑定连锁机构？
                <router-link :to="{name:LinkTypeCode.InterlockSettings}" tag="a" target="_blank">
                  <span class="link">绑定连锁机构</span>
                </router-link>
              </div>
              <div>2. 门店名称修改之前的订单【出库单】和【发票】修改请联系客服。【联系客服：4001818000】</div>
            </div>
          </div>
        </div>
        <div class="flex-remind-footer">
          <van-button
            @click="
              () => {
                show_remind = false,
                selected_canuse_receipt!=2 ? form2.CorporateName = chooseInvoice.Name || auth.getCustomerName() : form.CorporateName = chooseInvoice.Name || auth.getCustomerName()
              }
            "
          >
            取消修改
          </van-button>
          <van-button
            color="#0F6EEA"
            :disabled="!form2.CorporateName"
            @click.stop="
              () => {
                show_remind = false
              }
            "
          >
            确认修改
          </van-button>
        </div>
      </div>
    </a-modal>
    <!-- 温馨提示 model end -->

    <!-- 留言 -->
    <!-- <div class="card">
			<div class="card-t">订单留言</div>
			<div class="card-i">
				<van-field v-model="getCreateOrderInfoParams.Note" rows="2" autosize type="textarea" maxlength="200" placeholder="选填，可填写您的其他要求与建议" show-word-limit />
			</div>
		</div> -->
    <!-- 金额明细 -->
    <div class="card">
      <div class="card-t">金额明细</div>
      <div class="card-i" style="padding: 0;">
        <!-- <div class="order-price-itm">
          <div class="left">商品盒数：</div>

          <div class="right">{{ OrderInfo.CommodityCount }} 盒</div>
        </div> -->
        <div class="order-price-itm">
          <div class="left">商品金额：</div>
          <div class="right">
            ￥{{ Math.abs(Math.round(OrderInfo.CommodityAmount * 100) / 100) }}
          </div>
        </div>
        <div v-if="OrderInfo.ExchangeAmount" class="order-price-itm">
          <div class="left">换购金额：</div>
          <div class="right">
            ￥{{ Math.abs(Math.round(OrderInfo.ExchangeAmount * 100) / 100) }}
          </div>
        </div>

        <div v-if="OrderInfo.FreebieAmount" class="order-price-itm">
          <div class="left">赠品金额：</div>
          <div class="right">
            ￥{{ Math.abs(Math.round(OrderInfo.FreebieAmount * 100) / 100) }}
          </div>
        </div>

        <div v-if="OrderInfo.ActivityDiscount" class="order-price-itm">
          <div class="left">活动优惠：</div>
          <div class="right">
            - ￥{{ Math.abs(Math.round(OrderInfo.ActivityDiscount * 100) / 100) }}
          </div>
        </div>

        <div v-if="OrderInfo.ExchangeDiscount" class="order-price-itm">
          <div class="left">换购优惠：</div>
          <div class="right">
            - ￥{{ Math.abs(Math.round(OrderInfo.ExchangeDiscount * 100) / 100) }}
            <!-- </span> -->
          </div>
        </div>

        <div v-if="OrderInfo.FreebieDiscount" class="order-price-itm">
          <div class="left">赠品优惠：</div>
          <div class="right">
            -￥{{
              Math.abs(
                Math.round(OrderInfo.FreebieDiscount * 100) / 100
              )
            }}
          </div>
        </div>

        <div v-if="OrderInfo.CouponDiscount" class="order-price-itm">
          <div class="left">优惠券：</div>
          <div class="right">
            - ￥{{
              Math.abs(Math.round(OrderInfo.CouponDiscount * 100) / 100)
            }}
          </div>
        </div>
        <div v-if="OrderInfo.DiscountAmount" class="order-price-itm">
          <div class="left" style="position: relative;">客户折扣:
            <i
              class="is-sys-choose-tips"
            >享{{ OrderInfo.CustomerDiscountRatio }}折</i>
          </div>
          <div class="right">
            - ￥{{
              Math.abs(Math.round(OrderInfo.DiscountAmount * 100) / 100)
            }}
          </div>
        </div>

        <div class="order-price-itm">
          <div class="left">总优惠金额：</div>

          <div class="right">
            - ￥{{ _moneyFormat(OrderInfo.TotalDiscount) }}
          </div>
        </div>

        <div class="order-price-itm">
          <div class="left">
            运费{{ OrderInfo.LogisticsAmount == 0 ? '(包邮)' : '' }}：
          </div>
          <div class="right">
            ￥
            {{
              OrderInfo.LogisticsAmount == 0
                ? '0.00'
                : Math.abs(Math.round(OrderInfo.LogisticsAmount * 100) / 100)
            }}
          </div>
        </div>
        <!-- 返券 -->
        <div
          v-if="
            OrderInfo.OrderGiveCoupons && OrderInfo.OrderGiveCoupons.length > 0
          "
          class="coupons"
        >
          <div class="coupons-tag">返券</div>
          <div
            v-for="(cps, index) in OrderInfo.OrderGiveCoupons"
            :key="cps.CouponId + index"
            class="coupons-content"
          >

            <span> {{ cps.SimpleName }}*{{ cps.Count }} <span v-if="(OrderInfo.OrderGiveCoupons.length-1)!==index">;</span> </span>
          </div>
        </div>
        <!-- 提交 -->
        <div class="submit">
          <div class="money">
            <div>应付金额：</div>

            <div>
              <span
                v-if="OrderInfo.Amount !=OrderInfo.ActualAmount"
                class="line_down"
              >￥{{
                _moneyFormat(
                  OrderInfo.Amount
                )
              }}</span>￥ {{ _moneyFormat(OrderInfo.ActualAmount) }}
            </div>
          </div>
          <div class="address">
            <div>
              客户名称：{{ OrderInfo.CustomerReceivingAddress.CustomerName }}
            </div>
            <div>
              收货人：{{
                OrderInfo.CustomerReceivingAddress.ReceivingMan || ''
              }}
              {{ OrderInfo.CustomerReceivingAddress.Phone || '' }}
            </div>
            <div>
              收货地址：
              <span>{{
                OrderInfo.CustomerReceivingAddress.Area
                  ? OrderInfo.CustomerReceivingAddress.Area.Province
                  : ''
              }}</span>
              <span>{{
                OrderInfo.CustomerReceivingAddress.Area
                  ? OrderInfo.CustomerReceivingAddress.Area.City
                  : ''
              }}</span>
              <span>{{
                OrderInfo.CustomerReceivingAddress.Area
                  ? OrderInfo.CustomerReceivingAddress.Area.County
                  : ''
              }}</span>
              <span>{{
                setStreet(
                  OrderInfo.CustomerReceivingAddress.Address,
                  OrderInfo.CustomerReceivingAddress.AddressName
                ) || ''
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button
        class="button"
        color="#FF3939"
        size="large"
        :loading="loading"
        @click.stop="goPay"
      >去支付
      </van-button>
    </div>
    <!-- 优惠券对话框 -->
    <van-overlay v-if="show_coupon" :show="show_coupon" z-index="5">
      <div class="coupondalog">
        <div class="coupondalog-t">选择优惠券</div>
        <div class="coupon-tabs">
          <ul>
            <li
              :class="{ active: tabIndex == 0 }"
              style="cursor: pointer; text-align: center;"
              @click="handleTabsChange(0)"
            >
              <div :class="{ active: tabIndex == 0 }">
                可用优惠券（{{ OrderInfo.CouponsCanUse.length }}）
              </div>
            </li>
            <li
              :class="{ active: tabIndex == 1 }"
              style="cursor: pointer; text-align: center;"
              @click="handleTabsChange(1)"
            >
              <div :class="{ active: tabIndex == 1 }">
                不可用优惠券（{{ OrderInfo.CouponsCanNotUse.length }}）
              </div>
            </li>
          </ul>
          <van-list
            v-show="tabIndex == 0"
            :finished="true"
            :finished-text="''"
            class="coupon-lst"
          >
            <div
              v-for="itm in OrderInfo.CouponsCanUse"
              :key="itm.Id"
              class="coupon-itm"
            >
              <div class="coupon-left" :class="{ disabled: !itm.IsCanUse }">
                <span v-if="itm.DeductionMode == 1">
                  {{ itm.DeductionLimit }}
                  <img
                    v-if="itm.IsCanUse"
                    src="../../assets/coupon-money.png"
                  >
                  <img v-else src="../../assets/coupon-money-disable.png">
                </span>
                <span v-if="itm.DeductionMode == 2">
                  {{ (itm.DeductionLimit * 10).toFixed(1) }}
                  <img
                    v-if="itm.IsCanUse"
                    src="../../assets/coupon-discount.png"
                  >
                  <img v-else src="../../assets/coupon-discount-disabled.png">
                </span>
                <span v-if="itm.DeductionMode == 3">
                  全
                  <img
                    v-if="itm.IsCanUse"
                    src="../../assets/coupon-money.png"
                  >
                  <img v-else src="../../assets/coupon-money-disable.png">
                </span>
                <span
                  v-if="itm.GoodsLimitPrice > 0"
                >满{{ itm.GoodsLimitPrice }}元可用</span>
                <span
                  v-if="itm.GoodsLimitNumber > 0"
                >满{{ itm.GoodsLimitNumber }}盒可用</span>
              </div>
              <div
                class="coupon-context"
                style="
                  flex-direction: row;
                  align-items: center;
                  border-left: none;
"
                :style="{ borderColor: itm.IsCanUse ? '#0F6EEA' : '#E8E8E8' }"
              >
                <div
                  class="coupon-context"
                  style="border: none; box-shadow: none;"
                >
                  <div class="top">
                    <span v-if="itm.type == 1">全场通用</span>
                    <span v-if="itm.type == 2">原价商品可用</span>
                    <span v-if="itm.type == 3">指定活动可用</span>
                    <span v-if="itm.type == 4">指定商品可用</span>
                    <span v-if="itm.type == 5">
                      仅购买【{{
                        itm.OutCouponLimitGoodsDtos[0].GoodsName
                      }}】可用
                    </span>
                  </div>
                  <span
                    v-if="itm.ValidityEndTime"
                    class="bottom"
                  >有效期至：{{ itm.ValidityEndTime }}</span>
                  <span
                    v-if="itm.FailureDays"
                    class="bottom"
                  >领取后{{ itm.FailureDays }}天有效</span>
                </div>
                <div class="coupon-right">
                  <van-checkbox
                    v-model="itm.IsSelected"
                    :disabled="!itm.IsCanUse"
                    @change="onCouponChanged($event, itm)"
                  />
                </div>
              </div>
            </div>
            <EmptyControl
              v-if="
                !OrderInfo.CouponsCanUse || OrderInfo.CouponsCanUse.length == 0
              "
              type="coupon"
              text="暂无可用优惠券哦～"
            />
          </van-list>
          <van-list
            v-show="tabIndex == 1"
            :finished="true"
            :finished-text="''"
            class="coupon-lst"
          >
            <div
              v-for="itm in OrderInfo.CouponsCanNotUse"
              :key="itm.Id"
              class="coupon-itm"
            >
              <div class="coupon-left" :class="{ disabled: !itm.IsCanUse }">
                <span v-if="itm.DeductionMode == 1">
                  {{ itm.DeductionLimit }}
                  <img
                    v-if="itm.IsCanUse"
                    src="../../assets/coupon-money.png"
                  >
                  <img v-else src="../../assets/coupon-money-disable.png">
                </span>
                <span v-if="itm.DeductionMode == 2">
                  {{ (itm.DeductionLimit * 10).toFixed(1) }}
                  <img
                    v-if="itm.IsCanUse"
                    src="../../assets/coupon-discount.png"
                  >
                  <img v-else src="../../assets/coupon-discount-disabled.png">
                </span>
                <span v-if="itm.DeductionMode == 3">
                  全
                  <img
                    v-if="itm.IsCanUse"
                    src="../../assets/coupon-money.png"
                  >
                  <img v-else src="../../assets/coupon-money-disable.png">
                </span>
                <span
                  v-if="itm.GoodsLimitPrice > 0"
                >满{{ itm.GoodsLimitPrice }}元可用</span>
                <span
                  v-if="itm.GoodsLimitNumber > 0"
                >满{{ itm.GoodsLimitNumber }}盒可用</span>
              </div>
              <div
                class="coupon-context"
                style="
                  flex-direction: row;
                  align-items: center;
                  border-left: none;
"
                :style="{ borderColor: itm.IsCanUse ? '#0F6EEA' : '#E8E8E8' }"
              >
                <div
                  class="coupon-context"
                  style="border: none; box-shadow: none;"
                >
                  <div class="top" :class="{ disabledText: !itm.IsCanUse }">
                    <span v-if="itm.type == 1">全场通用</span>
                    <span v-if="itm.type == 2">原价商品可用</span>
                    <span v-if="itm.type == 3">指定活动可用</span>
                    <span v-if="itm.type == 4">指定商品可用</span>
                    <span v-if="itm.type == 5">
                      仅购买【{{
                        itm.OutCouponLimitGoodsDtos[0].GoodsName
                      }}】可用
                    </span>
                  </div>
                  <span v-if="itm.ValidityEndTime" class="bottom">
                    <!-- {{ hys.formateDatetime(itm.ValidityBeginTime, 'YYYY.MM.DD') }} - {{ hys.formateDatetime(itm.ValidityEndTime, 'YYYY.MM.DD') }} -->
                    有效期至：{{ itm.ValidityEndTime }}
                  </span>
                  <span
                    v-if="itm.FailureDays"
                    class="bottom"
                  >领取后{{ itm.FailureDays }}天有效</span>
                </div>
                <div class="coupon-right">
                  <van-checkbox
                    v-model="itm.IsSelected"
                    :disabled="!itm.IsCanUse"
                  />
                </div>
              </div>
            </div>
            <EmptyControl
              v-if="
                !OrderInfo.CouponsCanNotUse ||
                  OrderInfo.CouponsCanNotUse.length == 0
              "
              type="coupon"
              text="暂无可用优惠券哦～"
            />
          </van-list>
          <div class="coupon-floor">
            <van-button @click="show_coupon = false">返回</van-button>
            <!-- <van-button color="#0F6EEA"
                                    @click.stop="
								() => {
									getCreateOrderInfo();
									show_coupon = false;
								}
							"
                                    :disabled="!getCreateOrderInfoParams.CouponId">
                            确定
                        </van-button> -->
            <van-button
              color="#0F6EEA"
              @click.stop="
                () => {
                  getCreateOrderInfo()
                  show_coupon = false
                }
              "
            >
              确定
            </van-button>
          </div>
        </div>
      </div>
    </van-overlay>

    <iDialog
      v-model="show_pricechange"
      msg="商品价格发生变化！"
      confirm-btn-text="继续下单"
      cancel-btn-text="重新选择"
      @confirm="
        () => {
          show_pricechange = false
          goPay()
        }
      "
      @cancel="show_pricechange = false"
    />

    <iFooter />
    <!-- 查看更多弹出框 -->
    <el-dialog :visible.sync="moreInfoDiag" title="商品列表">
      <div style=" overflow-y: scroll; padding: 10px; height: 300px;">
        <div>仅限购买:</div>
        <div>
          {{
            infoList
              .map((i) => {
                return i.SkuName
              })
              .join('、')
          }}
        </div>
      </div>
    </el-dialog>
    <GiftDaigItem
      ref="GiftDaigItem"
      :activitys="ActivitysReturn"
      :commodity-gifts="OrderInfo.CommodityGifts"
      @surenext="surenext"
    />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iFooter from '@/components/Footer'
import iNav from '@/components/Nav'
import { LinkTypeCode } from '../../dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin'
import iFile from '@/components/uploader.vue'
import GiftDaigItem from './components/GiftDaigItem.vue'
import { Dialog } from 'vant'
import ProductDetails from './modules/ProductDetails'

export default {
  name: 'ConfirmOrder',
  components: {
    iHeader,
    iFooter,
    iNav,
    iFile,
    ProductDetails,
    GiftDaigItem
  },
  mixins: [BaseMixin],
  data() {
    const tab = {
      loading: false,
      finished: false,
      pageindex: 0,
      pageSize: 10,
      count: 0,
      data: []
    }
    return {
      activityList: [
        {
          name: '折扣',
          show: false,
          gifts: [1]
        },
        {
          name: '满减',
          show: false,
          gifts: [1, 2, 2, 2, 2, 2, 2]
        }
      ],
      originOrderAmountActualSum: null, // 购物车结算时提交的商品总价
      isShowCoupon: false,
      // 发票判断对象
      detailInfo: {},
      // 物流说明 model，默认关闭
      tipsModel: false,
      // 发票类型
      hasSwitchOptions: [
        {
          label: '电子普通发票',
          value: 1
        },
        {
          label: '增值税专用发票',
          value: 2
        }
      ],
      // 物流种类
      ExressName: '',
      // 发票选择校验字段
      isBoolean: true,
      isdisplay: true,
      click: false,
      selected_canuse_receipt: '',
      typeTo: '',
      fpType: '请选择',
      OrderInvoiceMediumType: '',
      activeKey: [],
      priceType: '',
      outboundType: '当前门店', // 出库单单位
      Id: '',
      IsDetail: false,
      PriceModel: 1,
      LinkTypeCode,
      tabIndex: 0,
      couponTabs: [tab, tab],
      conUploader: [],
      conUploader2: [],
      loading: false,
      customerName: '',
      // 选择优惠券弹窗
      show_coupon: false,
      // 选择发票痰喘
      show_price: false,
      // 温馨提示弹窗
      show_remind: false,
      difference: 1,
      // 选择发票单位弹窗
      show_outbound: false,
      // 选择收货地址弹窗
      show_address: false,
      selected_canuse_coupon: true,
      // 显示产品清单弹窗
      show_products: false,
      // 显示价格变动弹窗
      show_pricechange: false,
      // 购物车确认的商品
      confirmGoods: [],
      // 地址列表
      addressList: [],
      // 出库单位List
      CustomerList: [],
      OrderInfo: null,
      OrderSign: '',
      CreateInfo: null,
      getCreateOrderInfoParams: {
        // 商品ID
        Commoditys: [],
        // 优惠券ID
        CouponId: '',
        // 收货人ID
        OrderReceivedCustomerId: '',
        // 发票客户ID
        OrderInvoiceCustomerId: '',
        // 留言
        Note: '',
        sign: '',
        CreateInvoiceInfoDto: {}
      },
      url: {
        getCreateOrderInfo: '/api_order/Orders/ConfirmOrderV2',
        createOrder: '/api_order/Orders/SubmitOrderV2',
        getOrderPayInfo: '/api_pay/ExpenseApplications/GetOrderPayInfo',
        goods: '/api_goods/GoodsSku/RandomGetGoodsList'
      },
      form: {
        IdentificationNumber: '',
        BankDeposit: '',
        BankAccount: '',
        CorporateName: '',
        Address: '',
        Phone: ''
      },
      form2: {
        CorporateName: '',
        IdentificationNumber: ''
      },
      chooseInvoice: {}, // 选择的发票
      chooseCouponInfo: {}, // 已选优惠券信息，如果用户有优惠券，订单默认会返回系统已选择的最优优惠券信息
      moreInfoDiag: false,
      infoList: [],
      // loading: false,
      Activitys: [], // 购物车传来的活动
      ActivitysReturn: null, // 下单返回的异常活动商品
      OriginOrderId: null, // 原订单Id,
      FreebieAmount: null,
      preFormData: null,
      IsHead: false
    }
  },
  async created() {
    const cusInfo = this.$auth.getCustomerOtherInfo()
    if (!cusInfo || !cusInfo.IsOrder) {
      this.$toast({
        position: 'bottom',
        message:
          cusInfo && cusInfo.NoOrderMsg ? cusInfo.NoOrderMsg : '暂时不能下单'
      })
      this.$router.push(LinkTypeCode.Home)
      return
    }

    const {
      goods,
      preFormData,
      order,
      OrderAmountActualSum,
      Activitys,
      OriginOrderId,
      FreebieAmount
    } = this.$route.params
    if (goods) {
      this.confirmGoods = goods
      this.preFormData = preFormData
    } else {
      window.history.back()
      return
    }
    if (OriginOrderId) {
      this.OriginOrderId = OriginOrderId
    }
    this.FreebieAmount = FreebieAmount
    this.OrderInfo = order
    this.Activitys = Activitys
    this.originOrderAmountActualSum = OrderAmountActualSum
    this.initCouponInfo()
    if (!this.OrderInfo) {
      await this.getCreateOrderInfo()
    } else {
      // order存在的时候初始化值
      if (!this.getCreateOrderInfoParams.OrderReceivedCustomerId) {
        this.getCreateOrderInfoParams.OrderReceivedCustomerId =
          this.OrderInfo.CustomerReceivingAddress.CustomerId
      }

      this.GetCustomerReceivingAddressExpress()
    }

    this.customerName = this.OrderInfo.CustomerReceivingAddress.CustomerName
    // 判断是否需要显是发票地址
    // this.getIsInvoicOrNot();
    this.IsInvoicOrNotByCustomerId()
    // 发票列表
    await this.GetInvoiceInformationList()
    // 出库单位
    this.GetCustomerList()
  },
  mounted() {
    if (!this.confirmGoods) {
      window.history.back()
      return
    }
    this.Id = this.$route.params.Id || ''
    // this.loadData();
    this.judgHeadStore()
  },
  methods: {
    async judgHeadStore() {
      const res = await this.getAction(
        '/api_customers/MutiCustomer/JudgHeadStore'
      )
      if (res.IsSuccess && res.Data && res.Data.Type == 1) {
        this.IsHead = true
      }
    },
    // 改变状态
    changeShow(item) {
      item.show = !item.show
    },
    // 获取配送方式
    async GetCustomerReceivingAddressExpress() {
      const GetCustomerReceivingAddressExpressrEes = await this.getAction(
        '/api_customers/Customer/GetCustomerReceivingAddressExpressByCustomerId',
        {
          CustomerId: this.getCreateOrderInfoParams.OrderReceivedCustomerId
        }
      )
      if (
        GetCustomerReceivingAddressExpressrEes.IsSuccess &&
        GetCustomerReceivingAddressExpressrEes.Data
      ) {
        this.ExressName = GetCustomerReceivingAddressExpressrEes.Data.ExressName
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
        return
      }
    },
    // 选择发票
    chooseInvose() {
      const data = this.CustomerList.filter(
        (item) =>
          item.Id == this.getCreateOrderInfoParams.OrderInvoiceCustomerId
      )[0]
      if (data.IsMain && data.TaxNumber == null) {
        this.$message.warning('该主店没有更新过发票,无法选择')
        this.getCreateOrderInfoParams.OrderInvoiceCustomerId =
          this.CustomerList.filter((item) => !item.IsMain)[0].Id
        return
      }
      this.initInvoice()
    },
    // 确认选择地址
    comfirmChooseAddress() {
      this.show_address = false
      this.getCreateOrderInfo()
      this.IsInvoicOrNotByCustomerId()
    },
    // 查看更多
    async moreInfoBtn(item) {
      this.loading = true
      const res = await this.getAction('/api_coupon/Coupon/GetCouponGoods', {
        packageId: item.CouponPackageId ? item.CouponPackageId : item.Id
      })
      if (res.IsSuccess) {
        this.loading = false
        this.infoList = res.Data[0].CouponPackageGoodsList
        this.moreInfoDiag = true
      } else {
        this.loading = false
        this.$toast.fail(res.Msg)
      }
    },
    initCouponInfo() {
      if (this.OrderInfo) {
        this.filterCanUseList(this.OrderInfo.Coupons)
        this.choseCoupon()
      }
    },
    /**
     * 发票类型切换
     * xuzhongqi
     * 2020.12.07
     * @param {e} radio 当前选中对象
     */
    onChangeSwitch(e) {
      // 判断发票类型
      // 专项发票
      if (e.target.value === 2) {
        // 判断金额
        if (this.OrderInfo.ActualAmount < 500) {
          this.$toast({
            position: 'bottom',
            message: '商品实付金额小于500，请申请电子普通发票！'
          })
        } else {
          this.selected_canuse_receipt = e.target.value
        }
      } else {
        this.selected_canuse_receipt = e.target.value
      }
    },
    /**
     * 通过接口判断发票入口是否展示
     * xuzhongqi
     * 2020.12.24
     */
    async getIsInvoicOrNot(e) {
      const isInvoicOrNotRes = await this.getAction(
        '/api_order/Orders/IsInvoicOrNot'
      )
      // 判断返回布尔值
      if (isInvoicOrNotRes.IsSuccess) {
        this.isFuJian = isInvoicOrNotRes.Data
        if (isInvoicOrNotRes.Data) {
          // 包含福建地址，显示发票板块
          this.isBoolean = true
          this.chooseInvoice = this.OrderInfo.CustomerInvoiceList.filter(
            (item) => item.IsLast
          )[0]
          this.initInvoice()
          this.getCreateOrderInfoParams.OrderInvoiceCustomerId =
            this.chooseInvoice.CustomerId
        } else {
          // 不包含福建地址，隐藏发票板块
          this.isBoolean = false
          // 传递发票方式参数，0（暂不开票）
          this.selected_canuse_receipt = 0
          this.priceType = '暂不开票'
        }
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }
    },
    /**
     * 通过接口判断发票入口是否展示(连锁新增)
     * lt
     * 2020.09.10
     */
    async IsInvoicOrNotByCustomerId() {
      const isInvoicOrNotRes = await this.getAction(
        '/api_order/Orders/IsInvoicOrNotByCustomerId',
        {
          CustomerId: this.getCreateOrderInfoParams.OrderReceivedCustomerId
        }
      )
      // 判断返回布尔值
      if (isInvoicOrNotRes.IsSuccess) {
        this.isFuJian = isInvoicOrNotRes.Data
        if (isInvoicOrNotRes.Data) {
          // 包含福建地址，显示发票板块
          this.isBoolean = true

          this.getCreateOrderInfoParams.OrderInvoiceCustomerId =
            this.chooseInvoice.CustomerId
        } else {
          // 不包含福建地址，隐藏发票板块
          this.isBoolean = false
          // 传递发票方式参数，0（暂不开票）
          this.selected_canuse_receipt = 0
          this.priceType = '暂不开票'
        }
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }
    },
    /**
     * 通过接口获取出库单位列表(连锁新增)
     * lt
     * 2020.09.10
     * **/
    async GetCustomerList(e) {
      const res = await this.getAction(
        '/api_customers/MutiCustomer/CustomerList',
        {}
      )
      if (res.IsSuccess) {
        this.CustomerList = res.Data
        this.getCreateOrderInfoParams.OrderInvoiceCustomerId = res.Data.filter(
          (item) => item.IsDefault
        )[0].Id
        this.initInvoice()
      }
      // 判断返回布尔值
    },
    /**
     * 通过接口获取发票列表(连锁新增)
     * lt
     * 2020.09.10
     * **/
    async GetInvoiceInformationList(e) {
      const res = await this.getAction(
        '/api_customer/InvoiceInformation/List',
        {}
      )
      if (res.IsSuccess) {
        this.InvoiceInformationList = res.Data
      }
      // 判断返回布尔值
    },

    async toPrice() {
      this.priceType =
          this.selected_canuse_receipt == 1
            ? '电子普通发票'
            : this.selected_canuse_receipt == 2
              ? '增值税专用发票'
              : this.selected_canuse_receipt == 3
                ? '纸质普通发票'
                : '暂不开票'
      if (this.chooseInvoice.IsMain) {
        this.show_price = false
        return
      }
      let params = ''
      if (!this.selected_canuse_receipt) {
        this.$toast({
          position: 'bottom',
          message: '请选择发票类型'
        })
        return false
      }
      if (
        this.selected_canuse_receipt == 1 ||
        this.selected_canuse_receipt == 3
      ) {
        // 判断是否为诊所
        if (this.detailInfo.CustomerType === 2) {
          // 判断是否营利性
          if (this.detailInfo.BusinessNature === 1) {
            // 营利性
            if (this.form2['IdentificationNumber']) {
              if (
                !(
                  this.form2['IdentificationNumber'].length > 14 &&
                  this.form2['IdentificationNumber'].length < 26
                )
              ) {
                this.$toast({
                  position: 'bottom',
                  message: '请填写正确纳税人识别号'
                })
                return false
              }
            }
          }
        } else {
          // 药店，正常校验识别号
          if (this.form2['IdentificationNumber']) {
            if (
              !(
                this.form2['IdentificationNumber'].length > 14 &&
                this.form2['IdentificationNumber'].length < 26
              )
            ) {
              this.$toast({
                position: 'bottom',
                message: '请填写正确纳税人识别号'
              })
              return false
            }
          }
        }

        params = {
          Id: this.Id,
          Name: this.form2['CorporateName'],
          IdentificationNo: this.form2['IdentificationNumber'],
          BankOfDeposit: '',
          BankAccount: '',
          Address: '',
          Phone: this.detailInfo.Phone,
          IdentificationPicUrl: ''
        }
      } else {
        if (
          !(
            this.form['IdentificationNumber'].length > 14 &&
            this.form['IdentificationNumber'].length < 26
          )
        ) {
          this.$toast({
            position: 'bottom',
            message: '请填写正确纳税人识别号'
          })
          return false
        }
        params = {
          Id: this.Id,
          Name: this.form['CorporateName'],
          IdentificationNo: this.form['IdentificationNumber'],
          BankOfDeposit: this.form['BankDeposit'],
          BankAccount: this.form['BankAccount'],
          Address: this.form['Address'],
          Phone: this.form['Phone'],
          IdentificationPicUrl: this.conUploader[0]['ImageUrl'],
          IdentificationSummaryUrl: this.conUploader2.length ? this.conUploader2[0]['ImageUrl'] : null
        }
      }

      this.$hys.openLoading()
      const res = await this.putAction(
        '/api_customer/InvoiceInformation/AddOrUpdate',
        params
      )
      this.$hys.clearLoading()
      if (res.IsSuccess) {
        this.priceType =
          this.selected_canuse_receipt == 1
            ? '电子普通发票'
            : this.selected_canuse_receipt == 2
              ? '增值税专用发票'
              : this.selected_canuse_receipt == 3
                ? '纸质普通发票'
                : '暂不开票'
        this.$toast.success('提交成功')
        this.show_price = false
        setTimeout(() => {
          // this.conUploader = [];
          // this.conUploader2 = [];
          this.btn = false
          // this._back();
        }, 1500)
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
        this.btn = false
      }
    },
    async initInvoice() {
      this.chooseInvoice = this.InvoiceInformationList.filter(
        (item) =>
          item.CustomerId ==
          this.getCreateOrderInfoParams.OrderInvoiceCustomerId
      )[0]
      // this.chooseInvoice.['IsMain'] = this.CustomerList.filter((item)=> item.Id == this.getCreateOrderInfoParams.OrderInvoiceCustomerId)[0].IsMain
      this.$set(
        this.chooseInvoice,
        'IsMain',
        this.CustomerList.filter(
          (item) =>
            item.Id == this.getCreateOrderInfoParams.OrderInvoiceCustomerId
        )[0].IsMain
      )
      this.Id = this.chooseInvoice.Id
      this.form['IdentificationNumber'] =
        this.chooseInvoice.IdentificationNo || this.getCustomerInfo()
      this.form['BankDeposit'] = this.chooseInvoice.BankOfDeposit || ''
      this.form['BankAccount'] = this.chooseInvoice.BankAccount || ''
      this.form['CorporateName'] =
        this.chooseInvoice.Name || this.auth.getCustomerName()

      this.form['Address'] =
        this.chooseInvoice.Address ||
        (this.auth.getCustomerInfo()
          ? this.auth.getCustomerInfo()['Address']
          : '')
      this.form['Phone'] =
        this.chooseInvoice.Phone ||
        (this.auth.getCustomerInfo()
          ? this.auth.getCustomerInfo()['Phone']
          : '')
      this.form2['CorporateName'] =
        this.chooseInvoice.Name || this.auth.getCustomerName()
      this.form2['IdentificationNumber'] =
        this.chooseInvoice.IdentificationNo || this.getCustomerInfo()
      // 保存接口反回参数
      this.detailInfo = this.chooseInvoice
      if (this.chooseInvoice.IdentificationPicUrl) {
        this.conUploader = []
        this.conUploader.push({
          ImageUrl: this.chooseInvoice.IdentificationPicUrl
        })
      }
      if (this.chooseInvoice.IdentificationSummaryUrl) {
        this.conUploader2 = []
        this.conUploader2.push({
          ImageUrl: this.chooseInvoice.IdentificationSummaryUrl
        })
      }
      this.$hys.openLoading()
      const resTo = await this.getAction(
        '/api_aftersale/OrderInvoice/GetOrderInvoiceListByCustomerId'
      )
      this.$hys.clearLoading()
      if (resTo.IsSuccess) {
        if (resTo.Data === null) {
          this.priceType = '请选择'
        } else {
          this.priceType = resTo.Data.OrderInvoiceTypee_txt
          this.selected_canuse_receipt = resTo.Data.OrderInvoiceType
        }
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }
    },
    // 废弃
    async loadData() {
      this.$hys.openLoading()
      const res = await this.getAction(
        '/api_customer/InvoiceInformation/Detail'
      )

      if (res.IsSuccess && res.Data) {
        this.Id = res.Data.Id
        this.form['IdentificationNumber'] =
          res.Data.IdentificationNo || this.getCustomerInfo()
        this.form['BankDeposit'] = res.Data.BankOfDeposit || ''
        this.form['BankAccount'] = res.Data.BankAccount || ''
        this.form['CorporateName'] =
          res.Data.Name || this.auth.getCustomerName()
        this.form['Address'] =
          res.Data.Address ||
          (this.auth.getCustomerInfo()
            ? this.auth.getCustomerInfo()['Address']
            : '')
        this.form['Phone'] =
          res.Data.Phone ||
          (this.auth.getCustomerInfo()
            ? this.auth.getCustomerInfo()['Phone']
            : '')
        this.form2['CorporateName'] =
          res.Data.Name || this.auth.getCustomerName()
        this.form2['IdentificationNumber'] =
          res.Data.IdentificationNo || this.getCustomerInfo()
        // 保存接口反回参数
        this.detailInfo = res.Data
        if (res.Data.IdentificationPicUrl) {
          this.conUploader.push({
            ImageUrl: res.Data.IdentificationPicUrl
          })
        }
        if (res.Data.IdentificationSummaryUrl) {
          this.conUploader2.push({
            ImageUrl: res.Data.IdentificationSummaryUrl
          })
        }
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }

      // 根据客户下单地址匹配快递公司
      // xuzhongqi
      // 2020.12.08
      const GetCustomerReceivingAddressExpressrEes = await this.getAction(
        '/api_customers/Customer/GetCustomerReceivingAddressExpress'
      )
      if (
        GetCustomerReceivingAddressExpressrEes.IsSuccess &&
        GetCustomerReceivingAddressExpressrEes.Data
      ) {
        this.ExressName = GetCustomerReceivingAddressExpressrEes.Data.ExressName
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
        return
      }

      const resTo = await this.getAction(
        '/api_aftersale/OrderInvoice/GetOrderInvoiceListByCustomerId'
      )
      if (resTo.IsSuccess) {
        if (resTo.Data === null) {
          this.priceType = '请选择'
        } else {
          this.priceType = resTo.Data.OrderInvoiceTypee_txt
          this.selected_canuse_receipt = resTo.Data.OrderInvoiceType
        }
      } else {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
      }

      this.$hys.clearLoading()
    },
    // 获取客户信息
    async getCustomerInfo() {
      const res = await this.getAction(
        '/api_customers/Customer/GetBusinessLincenseAttr'
      )
      if (res.IsSuccess && res.Data.length > 0) {
        if (res.Data.length > 0) {
          this.form['IdentificationNumber'] =
            res.Data[0].CustomerAttrDtos[0].AttrValue || ''
          this.form2['IdentificationNumber'] =
            res.Data[0].CustomerAttrDtos[0].AttrValue || ''
        } else {
          this.form['IdentificationNumber'] = ''
          this.form2['IdentificationNumber'] = ''
        }
      } else {
        this.form['IdentificationNumber'] = ''
        this.form2['IdentificationNumber'] = ''
      }
    },
    delImage(index) {
      this.conUploader.splice(index, 1)
    },
    delImage2(index) {
      this.conUploader2.splice(index, 1)
    },
    onFile(file) {
      this.SignImage = file
      const img = {
        ImageUrl: this.SignImage
      }
      this.conUploader.push(img)
    },
    onFile2(file) {
      this.SignImage = file
      const img = {
        ImageUrl: this.SignImage
      }
      this.conUploader2.push(img)
    },
    changeOrderInvoiceMediumType(value) {
      this.OrderInvoiceMediumType = value.target.value
    },
    clickOrderInvoiceMediumType() {},
    async handleTabsChange(slot) {
      if (this.tabIndex != slot) {
        this.tabIndex = slot
      }
    },
    async getCreateOrderInfo() {
      if (this.getCreateOrderInfoParams.Commoditys.length == 0) {
        this.confirmGoods.forEach((w) => {
          this.getCreateOrderInfoParams.Commoditys.push({
            Id: w.GoodSkuId,
            Count: w.Count
          })
        })
      }
      this.$hys.openLoading()
      const {
        ActualAmount: OrderAmountActualSum,
        LogisticsAmount,
        OrderCouponDiscount,
        CommodityCouponDiscount,
        DiscountAmount
      } = this.OrderInfo

      const sendSum =
        (OrderAmountActualSum - LogisticsAmount || 0) +
        (OrderCouponDiscount + CommodityCouponDiscount + DiscountAmount - this.FreebieAmount)
      const { CouponId } = this.getCreateOrderInfoParams
      /**
       * SkipCoupon为约定字段，用户每次切换优惠券、不选优惠券而重新获取订单信息时传参
       */
      const formData = this.preFormData
      formData.OrderAmountActualSum = sendSum
      formData.SkipCoupon = !CouponId
      formData.OrderReceivedCustomerId = this.getCreateOrderInfoParams.OrderReceivedCustomerId
      formData.OriginOrderId = this.OriginOrderId
      formData.CouponId = CouponId
      const res = await this.postAction(this.url.getCreateOrderInfo, formData)
      this.$hys.clearLoading()
      if (!res.IsSuccess) {
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
        return
      }
      this.OrderInfo = res.Data
      this.FreebieAmount = res.Data.FreebieAmount
      if (this.getCreateOrderInfoParams.OrderReceivedCustomerId) {
        this.OrderInfo.CustomerReceivingAddress =
          this.OrderInfo.CustomerReceivingAddressList.filter(
            (item) =>
              item.CustomerId ==
              this.getCreateOrderInfoParams.OrderReceivedCustomerId
          )[0]
      } else {
        this.getCreateOrderInfoParams.OrderReceivedCustomerId =
          res.Data.CustomerReceivingAddress.CustomerId
      }

      this.GetCustomerReceivingAddressExpress()
      this.initCouponInfo()
    },
    // 过滤购物车结算返回的优惠券
    filterCanUseList(Coupons) {
      this.OrderInfo.CouponsCanUse = Coupons.filter((item) => item.IsCanUse)
      this.OrderInfo.CouponsCanNotUse = Coupons.filter((item) => !item.IsCanUse)
    },
    // 展示选中的优惠券信息
    choseCoupon() {
      const chooseCouponInfo = this.OrderInfo.CouponsCanUse.filter(
        (item) => item.IsSelected
      )[0]
      if (chooseCouponInfo) {
        this.getCreateOrderInfoParams.CouponId = chooseCouponInfo.Id || ''
        this.chooseCouponInfo = chooseCouponInfo
        //
      } else {
        this.chooseCouponInfo = {}
      }
    },
    // 重选可用优惠券
    onCouponChanged(e, item) {
      console.log(item.IsSelected)
      const { IsSelected, Id: itemId } = item

      if (IsSelected) {
        // 取消选中
        if (this.getCreateOrderInfoParams.CouponId == itemId) { this.getCreateOrderInfoParams.CouponId = '' }
        this.OrderInfo.CouponsCanUse.forEach((item) => {
          item.IsSelected = false
        })
      } else {
        // 选中新优惠券
        const nocur = this.OrderInfo.CouponsCanUse.filter(
          (tag) => tag.Id != item.Id && tag.IsSelected
        )
        nocur.forEach((item) => {
          item.IsSelected = false
        })
        this.getCreateOrderInfoParams.CouponId = item.Id
      }
      this.getCreateOrderInfo()
    },
    surenext(flag) {
      if (!flag) {
        this.ActivitysReturn = null
        return
      }
      this.goPay()
    },
    async goPay() {
      // 打开赠品弹窗
      // console.log()
      // this.$refs.GiftDaigItem.show = true
      // return
      // 判断地址是否包含福建
      // if (this.OrderInfo.CustomerReceivingAddress.AddressName.indexOf("福建") === -1) {
      // 	this.priceType = '暂不开票';
      // }
      // 商品失效标记
      // const IsPutaway = true
      if (!this.ExressName) {
        this.$toast({
          position: 'bottom',
          message: '暂未获取到快递信息，请稍后'
        })
        return false
      }
      if (!this.isBoolean) {
        this.priceType = '暂不开票'
      }
      if (this.priceType === '请选择' && this.isFuJian) {
        this.$toast({
          position: 'bottom',
          message: '请选择发票'
        })
        return false
      }
      if (this.priceType === '暂不开票') {
        this.$confirm('该订单您选择的暂不开票，系统将在90天后自动为您开具电子普通发票。', '温馨提示', {
          confirmButtonText: '去支付',
          cancelButtonText: '申请开票',
          center: true,
          distinguishCancelAndClose: true
        }).then(() => {
          this.goPayFun()
        }).catch(action => {
          // 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
          if (action === 'cancel') {
            this.show_price = true
          }
        })
      } else {
        this.goPayFun()
      }
    },
    async goPayFun() {
      if (this.getCreateOrderInfoParams.Commoditys.length == 0) {
        this.confirmGoods.forEach((w) => {
          this.getCreateOrderInfoParams.Commoditys.push({
            Id: w.ProductSKUId,
            Count: w.Count
          })
        })
      }

      // this.OrderInfo.Commoditys.forEach((item) => {
      //   if (!item.IsPutaway) {
      //     IsPutaway = item.IsPutaway
      //   }
      // })

      // // 验证商品失效状态
      // if (!IsPutaway) {
      //   this.$toast({
      //     position: 'bottom',
      //     message: '订单中包含已下架或失效商品，请重新下单'
      //   })
      //   return
      // }
      if (this.isFuJian) {
        this.getCreateOrderInfoParams['OrderInvoiceType'] =
          this.selected_canuse_receipt == 1 || this.selected_canuse_receipt == 3
            ? 1
            : 2
        this.getCreateOrderInfoParams['OrderInvoiceMediumTypes'] =
          this.selected_canuse_receipt == 1
            ? 1
            : this.selected_canuse_receipt == 0
              ? 0
              : 2
      } else {
        this.getCreateOrderInfoParams['OrderInvoiceMediumTypes'] = 0
      }

      this.loading = true
      this.getCreateOrderInfoParams.CreateInvoiceInfoDto['OrderInvoiceType'] =
        this.selected_canuse_receipt == 1 || this.selected_canuse_receipt == 3
          ? 1
          : 2
      this.getCreateOrderInfoParams.CreateInvoiceInfoDto[
        'OrderInvoiceMediumTypes'
      ] =
        this.selected_canuse_receipt == 1
          ? 1
          : this.selected_canuse_receipt == 0
            ? 0
            : 2
      this.getCreateOrderInfoParams.sign = this.OrderInfo.sign
      this.getCreateOrderInfoParams.Id = this.OrderInfo.OrderId
      this.getCreateOrderInfoParams.Activitys = this.ActivitysReturn ? this.ActivitysReturn : this.OrderInfo.Activitys
      this.getCreateOrderInfoParams.ReadyActivitys = (this.preFormData && this.preFormData.ReadyActivitys) ? this.preFormData.ReadyActivitys : null
      this.getCreateOrderInfoParams.OrderAmountActualSum =
        this.OrderInfo.ActualAmount
      this.getCreateOrderInfoParams.ExpressCompanyName = this.ExressName
      console.log(this.getCreateOrderInfoParams.ExpressCompanyName)
      const sendData = { ...this.getCreateOrderInfoParams }

      if (this.OriginOrderId) {
        delete sendData.Commoditys
        sendData.OriginOrderId = this.OriginOrderId
      }
      sendData.Commoditys = this.preFormData.Commoditys
      // 增加物流名称字段
      // xuzhongqi
      // 2020.12.09

      const res = await this.postAction(this.url.createOrder, sendData)
      if (!res.IsSuccess) {
        this.loading = false
        this.$toast({
          position: 'bottom',
          message: res.Msg
        })
        return
      }

      // 通知购物车数量
      this.$hys.getCartCount(this, true)

      if (res.Data.IsOrderInfoChanged) {
        this.OrderInfo = res.Data
        this.show_pricechange = true
        this.loading = false
        return
      }
      this.CreateInfo = res.Data
      if (this.CreateInfo.IsNotNeedPay) {
        this.goPaySuccess(this)
        return
      }
      let msg = ''
      if (res.Data.Code == 100010) {
        // 打开赠品弹窗
        res.Data.Activitys.forEach(v => {
          let tempsString = v.ActivityName + ' 活动,'
          v.Freebies.forEach(vvv => {
            tempsString += vvv.GoodsType == 3 ? '礼样品' : '换购品' + `${vvv.Name}不足`
            tempsString += `${vvv.Name}不足`
          })
          v.Freebies.length ? msg += tempsString : null
        })
        Dialog.confirm({
          title: '提示',
          message: msg,
          confirmButtonText: '继续',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.loading = false
            this.ActivitysReturn = res.Data.Activitys
          })
          .catch(() => {
            this.$router.push({
              name: LinkTypeCode.BuyCar
            })
          })
      }
      try {
        const res = await this.getAction(this.url.getOrderPayInfo, {
          id: this.CreateInfo.OrderId,
          no: this.CreateInfo.OrderNo
        })
        if (res && res.IsSuccess) {
          this.$router.push({
            name: LinkTypeCode.SelectPay,
            params: {
              OrderId: this.CreateInfo.OrderId,
              OrderNo: this.CreateInfo.OrderNo,
              PayMoney: res.Data.TotalAmountPaidActual,
              PayInfo: res.Data
            }
          })
        } else {
          this.$message.warring(res.Msg)
        }
      } catch (err) {
        this.$router.push(LinkTypeCode.MyOrder)
      } finally {
        this.loading = false
      }
    },
    async goPaySuccess(_this) {
      // 获取随机商品信息
      let goodsList = []
      const glst = await _this.getAction(_this.url.goods)
      _this.$hys.clearLoading()
      if (glst.IsSuccess) {
        goodsList = glst.Data
      }
      console.log(goodsList)
      _this.loading = false
      // 跳转支付成功
      this.$router.push({
        name: LinkTypeCode.PaySuccess,
        params: {
          payWay: this.payWay,
          payMoney: this.OrderInfo.ActualAmount,
          orderId: this.CreateInfo.OrderId
        }
      })
    },
    setStreet(address, areaName) {
      if (address && areaName && address.indexOf(areaName) != -1) {
        return address.substring(
          address.indexOf(areaName) + areaName.length,
          address.length
        )
      } else {
        return address
      }
    },
    checkName(_val) {
      const _old = this.chooseInvoice.Name || this.auth.getCustomerName()

      const l = _old.length > _val.length ? _old.length : _val.length
      const d = this.strSimilarity2Number(_old, _val)
      const difference = (d / l).toFixed(2) * 100
      if (difference > 0) {
        this.show_remind = true
        this.difference = difference <= 30 ? 1 : 2
      }
    },
    strSimilarity2Number(s, t) {
      const n = s.length
      const m = t.length
      const d = []
      let i, j, s_i, t_j, cost
      if (n == 0) return m
      if (m == 0) return n
      for (i = 0; i <= n; i++) {
        d[i] = []
        d[i][0] = i
      }
      for (j = 0; j <= m; j++) {
        d[0][j] = j
      }
      for (i = 1; i <= n; i++) {
        s_i = s.charAt(i - 1)
        for (j = 1; j <= m; j++) {
          t_j = t.charAt(j - 1)
          if (s_i == t_j) {
            cost = 0
          } else {
            cost = 1
          }
          d[i][j] = this.Minimum(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost)
        }
      }
      return d[n][m]
    },
    Minimum(a, b, c) {
      return a < b ? (a < c ? a : c) : (b < c ? b : c)
    },
    // 切换开票单位
    changeCompany() {
      this.show_price = false
      this.show_remind = false
      if (this.selected_canuse_receipt != 2) {
        this.form2.CorporateName = this.chooseInvoice.Name || this.auth.getCustomerName()
      } else {
        this.form.CorporateName = this.chooseInvoice.Name || this.auth.getCustomerName()
      }
    }
  }
}
</script>

<style lang="less">
@import url('~@/styles/confirmOrder.less');

.price-content {
  .origin-price {
    display: inline-block;
    margin-top: 8px;
    font-weight: 400;
    color: #858B9C;
    line-height: 16px;
  }

  .activePrice {
    display: block;
    display: flex;
    align-items: center;
    margin: 0 auto;
    border-radius: 4px;
    padding: 0 5px;
    max-width: max-content;
    height: 20px;
    font-size: 12px;
    color: #FFFFFF;
    background: linear-gradient(137deg, #FF6831 0%, #F3180E 100%);
    line-height: 20px;

    i {
      font-size: 16px;
      font-weight: 400;
      font-style: normal;
    }
  }
}

.flex-invoice-msg {
  padding-top: 10px;

  label {
    color: red;
  }
}

.ellips-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.coupon-box {
  padding: 20px;
  font-weight: 500;
  text-align: left;

  .up-down {
    cursor: pointer;
  }

  .c-num {
    margin-left: 20px;
    font-weight: 400;
  }

  .coupon-s {
    margin-left: 15px;
    color: #FF3939;
  }

  .s-text {
    margin-left: 20px;
  }

  .coupon-content {
    margin-top: 20px;
    border: 1px solid #E8E8E8;
    border-radius: 2px;

    .head {
      display: flex;
      border-bottom: 1px solid #E8E8E8;
      background: #F5F5F5;

      .item {
        padding: 10px 20px;
        color: #222222;
        cursor: pointer;
      }

      .active {
        color: #0F6EEA;
        background: #FFFFFF;
      }
    }

    .cs-box {
      overflow-y: auto;
      height: 362px;

      .c-p {
        display: flex;
        padding: 20px;
        padding-bottom: 0;
        flex-wrap: wrap;
      }

      .coupon-item {
        position: relative;
        display: flex;
        margin-right: 20px;
        margin-bottom: 20px;
        border: 1px solid #DFE1E8;
        border-radius: 8px 2px 2px 8px;
        width: 326px;
        height: 94px;
        background: #FFFFFF;
        cursor: pointer;
        box-sizing: border-box;

        .s-icon {
          position: absolute;
          right: 0;
          bottom: 0;
          z-index: 1;
          width: 39px;
          height: 39px;
          background-size: 100% 100%;
          background-image: url(../../assets/coupon-s.png);
        }

        .coupon-dis {
          position: absolute;
          top: 100%;
          left: -1px;
          z-index: 2;
          display: none;
          border: 1px solid #DFE1E8;
          padding: 10px;
          width: 326px;
          background: #FFFFFF;
          box-sizing: border-box;

          .dis-item {
            display: flex;
            margin-bottom: 6px;
            font-size: 12px;
            color: #858B9C;

            .dis-text {
              flex: 1;
            }
          }
        }

        .right {
          padding: 8px;
          flex: 1;
          line-height: normal;

          .q-tag {
            display: inline-block;
            border-radius: 4px;
            padding: 0 4px;
            height: 14px;
            font-size: 12px;
            color: #FFFFFF;
            background: linear-gradient(328deg, #FF6831 0%, #F3180E 100%);
            line-height: 14px;
          }

          .name {
            margin-left: 4px;
            font-size: 14px;
            color: #111A34;
            line-height: 16px;

            span {
              display: inline-block;
              max-width: 146px;
              text-overflow: ellipsis;
            }
          }

          .date {
            margin-top: 4px;
            font-size: 12px;
            color: #41485D;
          }

          .gz {
            display: inline-block;
            margin-top: 8px;
            font-size: 12px;
            color: #858B9C;

            .up {
              display: none;
            }

            .down {
              display: inline;
            }

            &:hover .up {
              display: inline;
            }

            &:hover .down {
              display: none;
            }

            &:hover .coupon-dis {
              display: block;
              opacity: 1;
            }
          }

          .gz-btn {
            cursor: pointer;
          }
        }

        .disabled-box {
          .q-tag {
            background: linear-gradient(346deg, #858B9C 0%, #C5CAD5 100%);
          }

          .name {
            color: #858B9C;
          }

          .date {
            color: #858B9C;
          }

          .gz {
            color: #858B9C;
          }
        }

        .left {
          position: relative;
          top: -1px;
          left: -1px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px 0 0 8px;
          width: 112px;
          height: 94px;
          background-size: 112px 94px;
          background-image: url(../../assets/coupon-normal.png);
          flex-direction: column;

          span {
            padding: 0 5px 0 10px;
            font-size: 12px;
            color: #FFFFFF;

            &:first-child {
              position: relative;
              padding: 0 5px;
              font-size: 40px;
              /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
              font-family: 'akrobatblack';
              letter-spacing: -1px;
              line-height: 40px;

              img {
                position: absolute;
                right: -9px;
                bottom: 2px;
                width: 20px;
                height: 20px;
              }
            }
          }
        }

        .disabled-left {
          background-image: url(../../assets/coupon-disabled.png) !important;
        }
      }

      .is-select {
        border: 1px solid #0F6EE9;
      }
    }
  }
}

.confirm-order {
  .active-panel {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 16px;
    border-radius: 2px;
    padding: 16px 0 16px 20px;
    width: 1200px;
    background: #FFEEEC;
    box-sizing: border-box;

    .active-list {
      display: flex;

      .ac-gifts {
        margin-left: 8px;

        .more-three {
          margin-top: 10px;
          font-size: 12px;
          text-align: left;
          color: #0F6EEA;
          cursor: pointer;
        }
      }

      .ac-tag {
        margin-top: 2px;
        border-radius: 4px;
        width: 32px;
        height: 16px;
        font-size: 12px;
        /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        background: linear-gradient(328deg, #FF6831 0%, #F3180E 100%);
        line-height: 15px;
      }

      .ac-content {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #111A34;

        .ac-is-gift {
          margin-left: 8px;
          font-size: 14px;
          /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FF3939;
        }
      }
    }
  }

  .card {
    margin: 0 auto;
    margin-top: 30px;
    border: 1px solid rgba(232, 232, 232, 1);
    width: 1200px;
    font-size: 14px;
    font-weight: 600;
    color: #222222;

    a {
      color: #0F6EEA;
    }

    &-t {
      padding-left: 20px;
      height: 50px;
      font-size: 16px;
      text-align: left;
      background-color: #F5F5F5;
      line-height: 50px;
      box-sizing: border-box;

      span {
        font-size: 16px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }

    &-i {
      padding-top: 20px;
      padding-left: 20px;
      box-sizing: border-box;

      .img {
        margin: 10px 0 30px;
        width: 180px;
        height: 60px;
        cursor: pointer;
      }

      .revc-info-itm {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 10px;
        font-weight: 400;

        .left {
          width: 100px;
          text-align: left;
          color: #999999;
        }

        .right {
          margin-left: 10px;

          span {
            margin-right: 8px;
          }
        }

        .el-icon-arrow-right {
          margin-right: 10px;
          font-size: 20px;
        }

        .tips {
          position: absolute;
          top: 0;
          right: 5px;
          font-size: 12px;
          color: rgba(15, 110, 234, 1);
          line-height: 20px;

          > a:hover {
            color: #0F6EEA;
          }

          > a:link {
            color: #0F6EEA;
          }

          > a:visited {
            color: #0F6EEA;
          }
        }
      }

      .pro-lst {
        position: relative;
        display: flex;
        border-bottom: 2px rgba(224, 224, 224, .3) solid;
        padding: 30px 0 30px 20px;
        text-align: left;
        box-sizing: border-box;

        .img-overlay,
        span {
          position: absolute;
          bottom: 30px;
          left: 20px;
          width: 100px;
          height: 25px;
          font-size: 14px;
          text-align: center;
          color: #FFFFFF;
          line-height: 25px;
        }

        .img-overlay {
          background-color: #FF3939;
          opacity: .6;
        }

        .pro-content {
          padding-left: 25px;
          width: 355px;

          .gname {
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #222222;
          }

          .gsize {
            margin-top: 10px;
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            color: #777777;
          }

          .name-title {
            flex: 1;
          }
        }

        .pro-col {
          width: 175px;
          font-size: 16px;
          font-weight: 400;
          text-align: center;
          color: #222222;
        }

        .pro-total {
          font-weight: 600;
          color: #FF3939;
        }

        &:last-child {
          border: none;
        }
      }

      .copun {
        border: 1px solid rgba(232, 232, 232, 1);
        width: 180px;
        height: 60px;
        font-size: 16px;
        text-align: center;
        color: rgba(153, 153, 153, 1);
        box-sizing: border-box;
        line-height: 60px;
        cursor: pointer;
      }

      .copun-sed {
        position: relative;
        height: 60px;
        text-align: center;
        color: #FF3939;
        background-size: 100%;
        line-height: 60px;

        > div {
          float: left;
          box-sizing: border-box;
        }

        .left {
          border: 1px #FF3939 solid;
          border-right: none;
          width: 140px;
          height: 60px;
          background-color: #FFE4E5;
        }

        .middle {
          width: 16px;
          height: 60px;
          background-image: url(../../assets/buycar/bg3.png);
        }

        .right {
          border: 1px #FF3939 solid;
          border-left: none;
          width: 71px;
          height: 60px;
          cursor: pointer;
        }
      }

      .copun-tip {
        margin-top: 20px;
        margin-bottom: 30px;
        font-size: 16px;
        color: #222222;
      }

      .order-price-itm {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 20px;
        font-size: 16px;
        font-weight: 400;

        .left {
          width: 100px;
          text-align: right;
          color: #999999;
        }

        .right {
          margin-left: 10px;
          padding-right: 20px;
          width: 300px;
          text-align: right;
          color: #FF3939;

          span {
            margin-right: 8px;
          }
        }
      }

      .coupons {
        display: flex;
        align-items: center;
        margin-top: 25px;
        min-height: 50px;
        background: rgba(255, 246, 216, 1);
        flex-wrap: wrap;

        .coupons-tag {
          margin-left: 20px;
          border-radius: 2px;
          padding: 2px 7px;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          background:
            linear-gradient(
              166deg,
              rgba(255, 134, 57, 1) 0%,
              rgba(255, 71, 71, 1) 100%
            );
        }

        .coupons-content {
          margin-left: 24px;
          font-size: 16px;
          color: #D3691F;
        }
      }

      .submit {
        padding: 25px 20px;
        background-color: #F8F8F8;

        .money,
        .address {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          > div {
            font-weight: normal;

            > span {
              margin-left: 10px;

              &:first-child {
                margin-left: 0;
              }
            }

            &:first-child {
              width: 100px;
              text-align: right;
              color: #999999;
            }

            &:last-child {
              width: 300px;
              font-size: 26px;
              text-align: right;
              color: #FF3939;
            }
          }
        }

        .address {
          margin-top: 10px;

          > div {
            margin-left: 30px;
            font-size: 14px;
            text-align: right;
            color: #999999;

            &:first-child {
              margin-left: 30px;
              width: auto;
              font-size: 14px;
              color: #999999;
            }

            &:last-child {
              margin-left: 30px;
              width: auto;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }

    &-f {
      margin-top: 30px;
      height: 3px;
      background-image: url(../../assets/buycar/bg1.png);
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 100px;
    width: 1200px;
    text-align: right;

    .button {
      width: 222px;
      height: 70px;
      font-size: 24px;
      font-weight: 600;
    }
  }

  .carName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;

    .cn {
      display: flex;
      align-items: flex-end;
      height: 100%;
    }
  }

  .coupondalog {
    position: relative;
    margin: 0 auto;
    margin-top: 100px;
    width: 1000px;
    height: 600px;
    background-color: #FFFFFF;

    &-t {
      padding-top: 20px;
      padding-bottom: 15px;
      height: 60px;
      box-sizing: border-box;
    }

    .coupon-lst {
      display: flex;
      justify-content: flex-start;
      overflow: auto;
      padding-left: 10px;
      max-height: 370px;
      flex-direction: row;
      flex-wrap: wrap;

      .coupon-itm {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        margin-left: 30px;
        width: 400px;
        height: 94px;
        flex-direction: row;

        .coupon-left {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100px;
          height: 94px;
          background-repeat: no-repeat;
          background-size: 100px 94px;
          background-image: url(../../assets/coupon-normal.png);
          flex-direction: column;

          span {
            padding: 0 5px 0 10px;
            font-size: 12px;
            color: #FFFFFF;

            &:first-child {
              position: relative;
              padding: 0 5px;
              font-size: 28px;
              /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
              font-family: 'akrobatblack';
              letter-spacing: -1px;
              line-height: 40px;

              img {
                position: absolute;
                right: -9px;
                bottom: 2px;
                width: 20px;
                height: 20px;
              }
            }
          }
        }

        .coupon-context {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border: 1px solid rgba(15, 110, 234, 1);
          padding-top: 10px;
          padding-left: 10px;
          width: ~'calc(100% - 100px)';
          height: 100%;
          box-shadow: 0 1px 5px 0 rgba(234, 234, 234, 1);
          flex-direction: column;
          box-sizing: border-box;

          > .top {
            span {
              &:first-child {
                border-radius: 10px;
                padding: 2px 10px;
                font-size: 10px;
                color: #FFFFFF;
                background-color: #4191F8;
              }

              &:last-child {
                padding: 2px 10px;
                font-size: 12px;
                color: #222222;
                vertical-align: middle;
              }
            }
          }

          > .bottom {
            padding-bottom: 12px;
            font-size: 10px;
          }
        }

        .coupon-right {
          margin-right: 10px;
        }

        .disabled {
          background-image: url(../../assets/coupon-disabled.png) !important;
        }

        .disabledText {
          span {
            &:first-child {
              background-color: #C2C2C2 !important;
            }

            &:last-child {
              color: #999999 !important;
            }
          }
        }

        .disabledText + .bottom {
          color: #999999 !important;
        }
      }
    }

    .coupon-floor {
      position: absolute;
      top: 520px;
      left: 0;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100px;

      button {
        width: 140px;
        height: 50px;
        font-size: 16px;
        color: #999999;

        &:first-child {
          margin-right: 30px;
        }
      }
    }

    .coupon-floor-more {
      position: absolute;
      top: 1020px;
      left: 0;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100px;

      button {
        width: 140px;
        height: 50px;
        font-size: 16px;
        color: #999999;

        &:first-child {
          margin-right: 30px;
        }
      }
    }
  }

  .coupon-tabs {
    margin: 0 auto;
    width: calc(100% - 20px);
    height: calc(100% - 80px);
    text-align: left;
    background: rgba(255, 255, 255, 1);

    > ul {
      margin-right: 20px;
      margin-left: 20px;
      border-bottom: 2px solid #3183EC;
      height: 70px;
      box-sizing: border-box;
    }

    > ul li {
      display: inline-block;
      margin-right: 50px;
      padding-top: 27px;
      padding-bottom: 16px;
      font-size: 14px;
      /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      text-align: center;
      color: black;

      &.active {
        border-bottom: 4px solid #0F6EE9;
        font-size: 16px;
      }
    }

    > ul li div {
      font-weight: 400;

      &.active {
        font-weight: 600;
        color: #0F6EEA;
      }
    }
  }
}

.price_title {
  padding: 45px 0;
  font-size: 16px;
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: '';
  font-weight: 500;
  color: #222222;
  line-height: 22px;
}

.rule {
  margin-right: 10px;
  color: red;
}

.price_p {
  font-size: 12px;
  font-weight: 400;
  color: #777777;
  line-height: 18px;
}

.select_border {
  border: 1px solid #FF3939 !important;
  padding: 15px 20px;
  color: #FF3939;
  background: #FFF3F3;
}

.unselect_border {
  border: 1px solid rgb(229, 229, 229);
  padding: 15px 20px;
}

.unclick {
  margin-top: 10px;
  border: 1px solid rgb(229, 229, 229);
  padding: 15px 20px;
  color: black;
  background: none;
}

.click {
  margin-top: 10px;
  border: 1px solid #FF3939;
  padding: 15px 20px;
  color: #FF3939;
  background: #FFF3F3;
}

/deep/ .confirm-order.coupondalog {
  min-height: 700px;
}

.inputType {
  /deep/.ant-input {
    margin-left: 4px;
  }
}

.customer-title {
  padding: 10px 20px;
  width: 100%;
  text-align: left;
  color: #D3691F;
  background: #FFF6D8;
}

.confirm-order .card-i .pro-lst .gname {
  display: flex;
  align-items: center;

  .tag-name {
    position: relative;
    bottom: 0;
    left: 0;
    display: inline-block;
    margin-right: 7px;
    border-radius: 4px;
    padding: 0 4px;
    width: auto;
    height: 16px;
    background: #F98900;
    line-height: 16px;
  }
}

.infoBtn_class {
  border: none;
  height: 100%;
  font-size: 10px;
  color: #0F6EEA;
}

.line_down {
  font-size: 16px;
  text-decoration: line-through;
  color: #999999;
}

.is-sys-choose-tips {
  position: absolute;
  top: 3px;
  display: inline-block;

  /* right: 0; */
  margin-left: 4px;
  border: 1px solid;
  border-radius: 4px;
  width: 48px;
  font-size: 12px;
  /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  text-align: center;
  color: #FF3939;
  font-style: normal;
}
</style>
